import { useEffect, EffectCallback } from 'react'

export function useMount(fn: EffectCallback) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(fn, [])
}

export default useMount
